import { h } from 'preact';
import { Link } from 'preact-router/match';
import {Info} from 'preact-feather';

import style from './style';

import InfoModal from '../../components/info';

const Header = ({title}) => (
	<header class={style.header}>
		<h1>{title}</h1>
		
		<InfoModal />
	</header>
);

export default Header;



// WEBPACK FOOTER //
// ./components/header/index.js